import React, { CSSProperties, ReactNode } from 'react';

import CustomTooltip from '../CustomTooltip/CustomTooltip';
import IconContainer from './IconContainer';

import './style.scss';

interface FtuxComponentProps {
  icon?: ReactNode;
  title?: string;
  text?: string;
  buttonText?: string;
  onClick?: () => void;
  buttonIcon?: ReactNode;
  buttonRightIcon?: ReactNode;
  height?: string | number;
  width?: string | number;
  buttonDisableStatus?: boolean;
  buttonTooltipText?: string;
  iconBgColor?: string;
  buttonStyles?: CSSProperties;
  titleStyle?: CSSProperties;
  textStyle?: CSSProperties;
  textClassName?: string;
  titleClassName?: string;
  iconClassName?: string;
  buttonClassName?: string;
}

export default function FtuxComponent({
  icon,
  title,
  text,
  buttonText,
  onClick,
  buttonIcon,
  buttonRightIcon,
  height,
  width = 320,
  buttonDisableStatus = false,
  buttonTooltipText = '',
  iconBgColor,
  buttonStyles,
  titleStyle,
  textStyle,
  textClassName = '',
  titleClassName = '',
  iconClassName,
  buttonClassName = '',
}: FtuxComponentProps) {
  return (
    <div className="ftux-container" style={{ height: height || 'calc(100vh - 150px)' }}>
      <div className="inner-container" style={{ maxWidth: width }}>
        {icon && <IconContainer bgColor={iconBgColor} icon={icon} className={iconClassName} />}
        {title && (
          <h2 className={titleClassName} style={{ ...titleStyle }}>
            {title}
          </h2>
        )}
        {text && (
          <div
            className={`text-container ${textClassName}`}
            style={{ ...textStyle }}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        )}
        {buttonText && (
          <CustomTooltip title={buttonTooltipText}>
            <button onClick={onClick} disabled={buttonDisableStatus} className={buttonClassName} style={buttonStyles}>
              {buttonIcon && buttonIcon} {buttonText} {buttonRightIcon && buttonRightIcon}
            </button>
          </CustomTooltip>
        )}
      </div>
    </div>
  );
}
